import React from 'react';

const iconStyle = { width: '1em', height: '1em', display: 'inline-block', verticalAlign: '-0.125em', flexShrink: 0 };

export const ArrowUpRightIcon = () => (
  <svg viewBox="0 0 24 24" style={iconStyle} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d="M6 18 18 6M6 6h12v12"/>
  </svg>
);

export const PlayIcon = () => (
  <svg viewBox="0 0 24 24" style={iconStyle} fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M8 5v14l11-7z"/>
  </svg>
);
